/* ============================================================
   BOOK SELECTORS
============================================================ */

export const selectBookState = (state) =>
  state.admin?.book || {};

export const selectBooks = (state) =>
  selectBookState(state).books || [];

export const selectBookChapters = (state) =>
  selectBookState(state).chapters || [];

export const selectBookLoading = (state) =>
  selectBookState(state).loading || false;

export const selectBookError = (state) =>
  selectBookState(state).error || null;

/**
 * Find a single book by its ID from the current books array
 */
export const selectBookById = (state, bookId) =>
  selectBooks(state).find((book) => Number(book.book_id) === Number(bookId)) || null;